import {useMutation} from "@apollo/client";
import {SaveFormAnswersDocument, SaveFormAnswersInput} from "generated/graphql";

export const useSaveFormAnswers = () => {
  const [mutate] = useMutation(SaveFormAnswersDocument);

  return (input: SaveFormAnswersInput) => mutate({ variables: { input } });
}